<template>
  <div>
    <navbarBox />
    <addtorcomponents />
  </div>
</template>

<script>
import navbarBox from "../components/navbarBox";
import addtorcomponents from "@/components/addtorcomponents.vue";
export default {
  components: { addtorcomponents, navbarBox },
};
</script>
